import { Badge } from '@chakra-ui/react';
import type { BadgeProps } from '@chakra-ui/react';

// Shared across the Quote Marketplace driver-reports flow (MVRErrorAlert.tsx) and
// the standalone MVR Request tool (mvr_request/components/MvrRequestStatus.tsx).
// Unrecognized statuses fall back to "Failed".
export type MVRDriverStatusValue =
  | 'pending'
  | 'completed'
  | 'failed'
  | 'timeout'
  | 'no_match'
  | 'cancelled';

interface MVRStatusBadgeProps extends Omit<
  BadgeProps,
  'colorScheme' | 'children'
> {
  status: MVRDriverStatusValue | string;
  isDuplicate?: boolean;
}

const getStatusBadge = (
  status: string,
  isDuplicate: boolean,
): { label: string; colorScheme: string } => {
  if (isDuplicate) {
    return { label: 'Duplicate', colorScheme: 'blue' };
  }
  switch (status) {
    case 'completed':
      return { label: 'Completed', colorScheme: 'green' };
    case 'timeout':
      return { label: 'Timeout', colorScheme: 'orange' };
    case 'no_match':
      return { label: 'Not Found', colorScheme: 'red' };
    case 'pending':
      return { label: 'Pending', colorScheme: 'blue' };
    case 'cancelled':
      return { label: 'Cancelled', colorScheme: 'gray' };
    default:
      return { label: 'Failed', colorScheme: 'red' };
  }
};

const MVRStatusBadge = ({
  status,
  isDuplicate = false,
  ...badgeProps
}: MVRStatusBadgeProps) => {
  const { label, colorScheme } = getStatusBadge(status, isDuplicate);

  return (
    <Badge
      colorScheme={colorScheme}
      fontSize="xs"
      fontWeight="500"
      {...badgeProps}
    >
      {label}
    </Badge>
  );
};

export default MVRStatusBadge;
